// extracted by mini-css-extract-plugin
export default {"root":"styles_root__H4Gam","textarea":"styles_textarea__mkHAy"};